/*!
 *
 * top-job.js
 *
 */

var data = require('senior');

var $elem = $('#JobList');

var getJob = function(d){
	return  '<section class="tp-Job_List_Item">'+
				'<a href="/jinji/company/senior/' + d.id +'.html" class="tp-Job_List_Item_Link">'+
					'<figure class="tp-Job_List_Item_Link_Img"><img src="/jinji/img/company/senior/'+ d.id +'_index.jpg" alt=""></figure>'+
					'<div class="tp-Job_List_Item_Link_Label">'+
						'<h3 class="tp-Job_List_Item_Link_Label_Title">' + d.name +'</h3>'+
						'<p class="tp-Job_List_Item_Link_Label_Summary">' + d.department +'</p>'+
					'</div>'+
				'</a>'+
			'</section>'
};

module.exports = function(){
	var _data = _.shuffle(data);
	var job = '';
	for( var i=0; i<6; i++ ){
		job += getJob(_data[i]);
	};
	$elem.append(job);
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/top-job.js
// module id = 26
// module chunks = 0